import { USER_LOGIN } from "../Actions/Utilites";


const INITIAL_STATE = {
    // User Sign Up and User SIgn In
    loginLoading: false,
    loginSuccess: false,
    loginFailure: false,
    loginError: null,
  };

export const SignupReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      // LogIn
      case USER_LOGIN.USER_LOGIN_REQUEST:
        return {
          ...state,
          loginLoading: true,
          loginSuccess: false,
          loginFailure: false,
          loginError: null,
        };
        case USER_LOGIN.USER_LOGIN_SUCCESS:
        return {
            ...state,
            loginLoading: false,
            loginSuccess: true,
            loginFailure: false,
            loginError: null,
        };
        case USER_LOGIN.USER_LOGIN_FAILURE:
        return {
            ...state,
            loginLoading: false,
            loginSuccess: false,
            loginFailure: true,
            loginError: action.payload,
        };
      default:
        return state;
    }
  };
  